
module.exports = function () { return eval('require'); };
